import { render, staticRenderFns } from "./TagsManagerListSentimentSelectorDropdown.vue?vue&type=template&id=0e2a16d4&scoped=true&"
import script from "./TagsManagerListSentimentSelectorDropdown.vue?vue&type=script&lang=js&"
export * from "./TagsManagerListSentimentSelectorDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TagsManagerListSentimentSelectorDropdown.vue?vue&type=style&index=0&id=0e2a16d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a16d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
